/** ***********************************************************************
 *
 * Copyright 2023 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ************************************************************************* */

// TODO: Remove this. We should not be maintaining a list of languages in the app.
export const supportedLanguages = [
	'cs',
	'cs-CZ',
	'da',
	'da-DK',
	'de',
	'de-AT',
	'de-CH',
	'de-DE',
	'de-LU',
	'en',
	'en-AU',
	'en-BE',
	'en-CA',
	'en-CY',
	'en-GB',
	'en-GR',
	'en-HK',
	'en-IE',
	'en-LU',
	'en-MT',
	'en-NZ',
	'en-x-AFRICA',
	'es',
	'es-AR',
	'es-CL',
	'es-CO',
	'es-ES',
	'es-MX',
	'es-PE',
	'es-x-LA',
	'fi',
	'fi-FI',
	'fr',
	'fr-BE',
	'fr-CA',
	'fr-CH',
	'fr-FR',
	'fr-LU',
	'hu',
	'id',
	'it',
	'it-CH',
	'it-IT',
	'ja',
	'ja-JP',
	'ko',
	'ko-KR',
	'nb',
	'nb-NO',
	'nl',
	'nl-BE',
	'nl-NL',
	'pl',
	'pl-PL',
	'pt',
	'pt-BR',
	'ro-RO',
	'ru',
	'ru-RU',
	'sv',
	'sv-SE',
	'th',
	'tr',
	'uk',
	'vi',
	'zh-Hans',
	'zh-Hant',
	'en-AE',
	'en-ID',
	'en-IL',
	'en-IN',
	'en-x-MENA',
	'en-MY',
	'en-PH',
	'en-SA',
	'en-SG',
	'en-TH',
	'en-VN',
	'en-ZA',
	'fr-MA',
	'zh-Hant-HK',
];

export const languagePickerList = {
	cs: {
		displayName: 'Čeština',
		typekitId: 'bwx4ctj',
	},
	'cs-CZ': {
		displayName: 'Čeština',
		typekitId: 'bwx4ctj',
	},
	da: {
		displayName: 'Dansk',
		typekitId: 'bwx4ctj',
	},
	'da-DK': {
		displayName: 'Dansk',
		typekitId: 'bwx4ctj',
	},
	de: {
		displayName: 'Deutsch',
		typekitId: 'bwx4ctj',
	},
	'de-AT': {
		displayName: 'Deutsch (Österreich)',
		typekitId: 'bwx4ctj',
	},
	'de-CH': {
		displayName: 'Deutsch (Schweiz)',
		typekitId: 'bwx4ctj',
	},
	'de-DE': {
		displayName: 'Deutsch (Deutschland)',
		typekitId: 'bwx4ctj',
	},
	'de-LU': {
		displayName: 'Deutsch (Luxembourg)',
		typekitId: 'bwx4ctj',
	},
	en: {
		displayName: 'English',
		typekitId: 'bwx4ctj',
	},
	'en-AU': {
		displayName: 'English (Australia)',
		typekitId: 'bwx4ctj',
	},
	'en-BE': {
		displayName: 'English (Belgium)',
		typekitId: 'bwx4ctj',
	},
	'en-CA': {
		displayName: 'English (Canada)',
		typekitId: 'bwx4ctj',
	},
	'en-CY': {
		displayName: 'Cyprus - English',
		typekitId: 'bwx4ctj',
	},
	'en-GB': {
		displayName: 'English (United Kingdom)',
		typekitId: 'bwx4ctj',
	},
	'en-GR': {
		displayName: 'English (Greece)',
		typekitId: 'bwx4ctj',
	},
	'en-HK': {
		displayName: 'English (Hong Kong)',
		typekitId: 'bwx4ctj',
	},
	'en-IE': {
		displayName: 'English (Ireland)',
		typekitId: 'bwx4ctj',
	},
	'en-LU': {
		displayName: 'English (Luxembourg)',
		typekitId: 'bwx4ctj',
	},
	'en-MT': {
		displayName: 'Malta - English',
		typekitId: 'bwx4ctj',
	},
	'en-NZ': {
		displayName: 'English (New Zealand)',
		typekitId: 'bwx4ctj',
	},
	'en-x-AFRICA': {
		displayName: 'English (Africa)',
		typekitId: 'bwx4ctj',
	},
	'en-ZA': {
		displayName: 'Africa -  English',
		typekitId: 'bwx4ctj',
	},
	'en-ID': {
		displayName: 'English (Indonesia)',
		typekitId: 'bwx4ctj',
	},
	'en-x-MENA': {
		displayName: 'English (Middle East and North Africa)',
		typekitId: 'bwx4ctj',
	},
	'en-IN': {
		displayName: 'English (India)',
		typekitId: 'bwx4ctj',
	},
	'en-AE': {
		displayName: 'English (United Arab Emirates)',
		typekitId: 'bwx4ctj',
	},
	'en-EG': {
		displayName: 'English (Egypt)',
		typekitId: 'bwx4ctj',
	},
	'en-SG': {
		displayName: 'English (Singapore)',
		typekitId: 'bwx4ctj',
	},
	'en-IL': {
		displayName: 'English (Israel)',
		typekitId: 'bwx4ctj',
	},
	'en-KW': {
		displayName: 'English (Kuwait)',
		typekitId: 'bwx4ctj',
	},
	'en-MY': {
		displayName: 'English (Malaysia)',
		typekitId: 'bwx4ctj',
	},
	'en-NG': {
		displayName: 'English (Nigeria)',
		typekitId: 'bwx4ctj',
	},
	'en-PH': {
		displayName: 'English (Philippines)',
		typekitId: 'bwx4ctj',
	},
	'en-QA': {
		displayName: 'English (Qatar)',
		typekitId: 'bwx4ctj',
	},
	'en-SA': {
		displayName: 'English (Saudi Arabia)',
		typekitId: 'bwx4ctj',
	},
	'en-TH': {
		displayName: 'English (Thailand)',
		typekitId: 'bwx4ctj',
	},
	'en-US': {
		displayName: 'English (United States)',
		typekitId: 'bwx4ctj',
	},
	'en-VN': {
		displayName: 'English (Vietnam)',
		typekitId: 'bwx4ctj',
	},
	'en-x-CIS': {
		displayName: 'English (Commonwealth of Independent States)',
		typekitId: 'bwx4ctj',
	},
	es: {
		displayName: 'Español',
		typekitId: 'bwx4ctj',
	},
	'es-AR': {
		displayName: 'Español (Argentina)',
		typekitId: 'bwx4ctj',
	},
	'es-CL': {
		displayName: 'Español (Chile)',
		typekitId: 'bwx4ctj',
	},
	'es-CO': {
		displayName: 'Español (Colombia)',
		typekitId: 'bwx4ctj',
	},
	'es-CR': {
		displayName: 'Español (Costa Rica)',
		typekitId: 'bwx4ctj',
	},
	'es-EC': {
		displayName: 'Español (Ecuador)',
		typekitId: 'bwx4ctj',
	},
	'es-GT': {
		displayName: 'Español (Guatemala)',
		typekitId: 'bwx4ctj',
	},
	'es-ES': {
		displayName: 'Español (España)',
		typekitId: 'bwx4ctj',
	},
	'es-MX': {
		displayName: 'Español (México)',
		typekitId: 'bwx4ctj',
	},
	'es-PE': {
		displayName: 'Español (Perú)',
		typekitId: 'bwx4ctj',
	},
	'es-PR': {
		displayName: 'Español (Puerto Rico)',
		typekitId: 'bwx4ctj',
	},
	'es-x-LA': {
		displayName: 'Español (Latinoamérica)',
		typekitId: 'bwx4ctj',
	},
	fi: {
		displayName: 'Suomi',
		typekitId: 'bwx4ctj',
	},
	'fi-FI': {
		displayName: 'Suomi',
		typekitId: 'bwx4ctj',
	},
	fr: {
		displayName: 'Français',
		typekitId: 'bwx4ctj',
	},
	'fr-BE': {
		displayName: 'Français (Belgique)',
		typekitId: 'bwx4ctj',
	},
	'fr-CA': {
		displayName: 'Français (Canada)',
		typekitId: 'bwx4ctj',
	},
	'fr-CH': {
		displayName: 'Français (Suisse)',
		typekitId: 'bwx4ctj',
	},
	'fr-FR': {
		displayName: 'Français (France)',
		typekitId: 'bwx4ctj',
	},
	'fr-LU': {
		displayName: 'Français (Luxembourg)',
		typekitId: 'bwx4ctj',
	},
	'fr-MA': {
		displayName: 'Morocco - France',
		typekitId: 'bwx4ctj',
	},
	id: {
		displayName: 'Bahasa Indonesia',
		typekitId: 'oyh5sui',
	},
	'id-ID': {
		displayName: 'Bahasa Indonesia',
		typekitId: 'oyh5sui',
	},
	it: {
		displayName: 'Italiano',
		typekitId: 'bwx4ctj',
	},
	'it-CH': {
		displayName: 'Italiano (Svizzera)',
		typekitId: 'bwx4ctj',
	},
	'it-IT': {
		displayName: 'Italiano (Italia)',
		typekitId: 'bwx4ctj',
	},
	hu: {
		displayName: 'Magyar',
		typekitId: 'bwx4ctj',
	},
	'hu-HU': {
		displayName: 'Magyar',
		typekitId: 'bwx4ctj',
	},
	ja: {
		displayName: '日本語',
		typekitId: 'jux8vgg',
	},
	'ja-JP': {
		displayName: '日本語',
		typekitId: 'jux8vgg',
	},
	ko: {
		displayName: '한국어',
		typekitId: 'wyy5ocs',
	},
	'ko-KR': {
		displayName: '한국어',
		typekitId: 'wyy5ocs',
	},
	nb: {
		displayName: 'Norsk',
		typekitId: 'bwx4ctj',
	},
	'nb-NO': {
		displayName: 'Norsk',
		typekitId: 'bwx4ctj',
	},
	nl: {
		displayName: 'Nederlands',
		typekitId: 'bwx4ctj',
	},
	'nl-BE': {
		displayName: 'Nederlands (België)',
		typekitId: 'bwx4ctj',
	},
	'nl-NL': {
		displayName: 'Nederlands (Nederland)',
		typekitId: 'bwx4ctj',
	},
	pl: {
		displayName: 'Polski',
		typekitId: 'bwx4ctj',
	},
	'pl-PL': {
		displayName: 'Polski',
		typekitId: 'bwx4ctj',
	},
	pt: {
		displayName: 'Português',
		typekitId: 'bwx4ctj',
	},
	'pt-BR': {
		displayName: 'Português (Brasil)',
		typekitId: 'bwx4ctj',
	},
	'pt-PT': {
		displayName: 'Português (Portugal)',
		typekitId: 'bwx4ctj',
	},
	ru: {
		displayName: 'Pусский',
		typekitId: 'bwx4ctj',
	},
	'ru-RU': {
		displayName: 'Русский (Россия)',
		typekitId: 'bwx4ctj',
	},
	'ru-x-CIS': {
		displayName: 'Русский (СНГ)',
		typekitId: 'bwx4ctj',
	},
	sv: {
		displayName: 'Svenska',
		typekitId: 'bwx4ctj',
	},
	'sv-SE': {
		displayName: 'Svenska',
		typekitId: 'bwx4ctj',
	},
	th: {
		displayName: 'ไทย',
		typekitId: 'nuj4fol',
	},
	'th-TH': {
		displayName: 'ไทย',
		typekitId: 'nuj4fol',
	},
	tr: {
		displayName: 'Türkçe',
		typekitId: 'bwx4ctj',
	},
	'tr-TR': {
		displayName: 'Türkçe',
		typekitId: 'bwx4ctj',
	},
	uk: {
		displayName: 'Україна',
		typekitId: 'oyh5sui',
	},
	'uk-UA': {
		displayName: 'Україна',
		typekitId: 'oyh5sui',
	},
	vi: {
		displayName: 'Tiếng Việt',
		typekitId: 'nfv3gof',
	},
	'vi-VN': {
		displayName: 'Tiếng Việt',
		typekitId: 'nfv3gof',
	},
	zh: {
		displayName: '简体中文',
		typekitId: 'iiq7hga',
	},
	'zh-Hans': {
		displayName: '简体中文',
		typekitId: 'iiq7hga',
	},
	'zh-Hans-CN': {
		displayName: '中文 (简体)',
		typekitId: 'iiq7hga',
	},
	'zh-Hant': {
		displayName: '繁體中文',
		typekitId: 'yhu0wjc',
	},
	'zh-Hant-HK': {
		displayName: '中文 (香港)',
		typekitId: 'yhu0wjc',
	},
	'zh-Hant-TW': {
		displayName: '中文 (繁體)',
		typekitId: 'yhu0wjc',
	},
	zz: {
		displayName: 'Test Locale (zz)',
		typekitId: 'bwx4ctj',
	},
	'zz-ZZ': {
		displayName: 'Test Locale (zz-ZZ)',
		typekitId: 'bwx4ctj',
	},
} as const;

// List of languages with regions to show in Universal Nav language picker
export const geoLanguageList = [
	'cs-CZ',
	'da-DK',
	'de-DE',
	'de-LU',
	'de-AT',
	'de-CH',
	'en-x-AFRICA',
	'en-AU',
	'en-BE',
	'en-CA',
	'en-x-CIS',
	'en-EG',
	'en-GR',
	'en-HK',
	'en-IN',
	'en-ID',
	'en-IE',
	'en-IL',
	'en-KW',
	'en-LU',
	'en-MY',
	'en-x-MENA',
	'en-NZ',
	'en-NG',
	'en-PH',
	'en-QA',
	'en-SA',
	'en-SG',
	'en-TH',
	'en-AE',
	'en-GB',
	'en-US',
	'en-VN',
	'es-AR',
	'es-CL',
	'es-CO',
	'es-CR',
	'es-EC',
	'es-ES',
	'es-GT',
	'es-x-LA',
	'es-MX',
	'es-PE',
	'es-PR',
	'fr-BE',
	'fr-CA',
	'fr-FR',
	'fr-LU',
	'fr-CH',
	'id-ID', // Indonesian (Indonesia)
	'it-IT',
	'it-CH',
	'hu-HU', // Hungarian (Hungary)
	'nl-BE',
	'nl-NL',
	'nb-NO',
	'pl-PL',
	'pt-BR',
	'pt-PT',
	'fi-FI',
	'sv-SE',
	'th-TH', // Thai (Thailand)
	'vi-VN', // Vietnamese (Vietnam)
	'tr-TR',
	'ru-RU',
	'ru-x-CIS',
	'ko-KR',
	'uk-UA', // Ukrainian (Ukraine)
	'zh-Hans-CN',
	'zh-Hant-TW',
	'zh-Hant-HK',
	'ja-JP',
	'zz-ZZ',
];

export const languageList = [
	'cs',
	'da',
	'de',
	'en',
	'es',
	'fr',
	'it',
	'nl',
	'nb',
	'pl',
	'pt',
	'fi',
	'sv',
	'tr',
	'ru',
	'zh-Hans',
	'zh-Hant',
	'ja',
	'ko',
	'hu',
	'id',
	'th',
	'uk',
	'vi',
	'zz',
];
